import styled from "styled-components";

import { fonts } from "../../../styles/variables";

import { AlignCenter } from "../../atoms/Aligned";
import OffCanvasTrayFooter from "../../molecules/OffCanvasTrayFooter";

import TasteChallengeHeader from "../../atoms/TasteChallengeHeader";
import { StyledCheckoutTotalItemPriceBold, StyledCheckoutTotal } from "../../atoms/CheckoutTotalList";

export const TopUpTrayHeader = styled(TasteChallengeHeader)``;

export const StyledSubmitBtnPrice = styled.span`
  font-size: 25px;
  font-family: ${fonts.fontInterstateBlackCompressed};
`;

export const CheckoutTotalItemPriceBoldWithMinWidth = styled(StyledCheckoutTotalItemPriceBold)`
  min-width: 40px;
  display: inline-block;
`;

export const StyledOffCanvasTrayFooter = styled(OffCanvasTrayFooter)`
  padding-top: 0px;
`;

export const TopUpTrayCheckoutTotal = styled(StyledCheckoutTotal)`
  margin-top: 0px;
`;

export const StyledAlignCenter = styled(AlignCenter)`
  padding-top: 5px;
`;

export const StyledAlignCenterSmall = styled(AlignCenter)`
  padding-top: 10px;
  font-size: 12px;
`;
